// extracted by mini-css-extract-plugin
module.exports = {"row":"BackBox_row__3moCU","backBoxMobile":"BackBox_backBoxMobile__D3v6r","icon":"BackBox_icon__2355c","logo":"BackBox_logo__3TXpV","mobileLogo":"BackBox_mobileLogo__2Yfk_"};